import { Form, Input, message as messager, Modal } from "antd";
import React, { useEffect, useState } from "react"
import { createMenu, getMenuEnum, getMenuNodes } from "../../../../services/system/menu";
import { addAdmEmail } from "../../../../services/plat/plat";

type Props = {
  onClose(refresh: boolean): void;
}
const CreateModal: React.FC<Props> = ({ onClose })=> {

  const [form] = Form.useForm();

  const initialValues = {
    email: ''
  }

  const createData = async ()=> {
    try {
      const data = await form.validateFields()

      const { code, message } = await addAdmEmail(data)

      if (code === 0) {
        messager.success('创建成功')
        onClose(true)
      } else {
        messager.error(message)
      }
    } catch (error) {
      console.log('?er', error)
    }
  }

  return (
    <Modal onOk={createData} onCancel={()=> onClose(false)} okText="创建" cancelText="取消" title="新增菜单" open={true} destroyOnClose closable>
      <Form form={form} initialValues={initialValues}>
        <Form.Item
          name="email"
          label="邮箱地址"
          labelCol={{span: 5}}
          rules={[
            {required: true, message: '邮箱地址不能为空'},
            {type: 'email', message: '邮箱地址填写错误'},
          ]}>
          <Input placeholder="请输入邮箱地址" allowClear/>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateModal